import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <>
      <div className="cookie-consent">
        <div className="cookie-content">
          <p>
            We use cookies to enhance your gaming experience and analyse site traffic. 
            By clicking "Accept", you consent to our use of cookies.{' '}
            <button 
              className="policy-link" 
              onClick={() => setShowPolicy(true)}
            >
              Privacy Policy
            </button>
          </p>
          <div className="cookie-buttons">
            <button className="accept-button" onClick={handleAccept}>
              Accept
            </button>
            <button className="decline-button" onClick={handleDecline}>
              Decline
            </button>
          </div>
        </div>
      </div>

      {showPolicy && (
        <div className="policy-modal" onClick={() => setShowPolicy(false)}>
          <div className="policy-content" onClick={(e) => e.stopPropagation()}>
            <div className="policy-header">
              <h2>Privacy Policy & Cookie Usage</h2>
              <button className="close-btn" onClick={() => setShowPolicy(false)}>✕</button>
            </div>
            <div className="policy-body">
              <h3>Cookie Policy</h3>
              <p>
                This website uses cookies to improve your experience while you navigate through the website. 
                These cookies are stored in your browser and help us understand how you use our site.
              </p>
              
              <h3>Types of Cookies We Use</h3>
              <ul>
                <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
                <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
                <li><strong>Preference Cookies:</strong> Remember your settings and preferences</li>
              </ul>

              <h3>Privacy & Data Protection</h3>
              <p>
                We are committed to protecting your privacy. We do not collect personal information 
                without your consent. All games are provided for entertainment purposes only.
              </p>

              <h3>Age Restriction</h3>
              <p>
                This website is intended for users 18 years of age and older. By using this site, 
                you confirm that you meet this age requirement.
              </p>

              <h3>Third-Party Content</h3>
              <p>
                Games on this platform are provided by third-party providers. Each game may have 
                its own privacy policy and terms of service.
              </p>

              <h3>Contact</h3>
              <p>
                If you have any questions about our privacy policy or cookie usage, please contact us.
              </p>
            </div>
            <div className="policy-footer">
              <button className="close-policy-btn" onClick={() => setShowPolicy(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CookieConsent;
